app.directive('sgExerciseBarResultsContainer', function () {
    return {
        restrict: 'C',
        link: function ($scope, $element) {
            var $innerContainer = $element.find('.sg-exercise-bar-results-container-inner');

            var setContainerHeight = function () {
                var firstElementToCapture = $element.find('.sg-program-editor-exercise-filter-result, .sg-program-editor-exercise-filter-no-results').first();
                var setHeightTo = firstElementToCapture[0].offsetHeight;
                $element.css('height', setHeightTo + 'px');
            };
            setContainerHeight();

            addResizeListener($innerContainer[0], setContainerHeight);

            $scope.$on('$destroy', function () {
                removeResizeListener($innerContainer[0], setContainerHeight);
            });
        }
    };
});